import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface HeadphonesIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const HeadphonesIcon: React.FC<HeadphonesIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon headphones')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512">
        <path d="M256 32C112.9 32 4.563 151.1 0 288l.0042 111.9c0 .8379 .3493 1.621 .4723 2.424C2.969 445.6 38.49 480 82.36 480C107.6 480 128 459.6 128 434.4V301.8C128 276.5 107.5 256 82.25 256C70.67 256 59.69 258.4 49.7 262.7C62.23 159.9 149.9 80.14 256 80.13c106.1 .0137 193.8 79.79 206.3 182.6C452.3 258.4 441.3 256 429.8 256C404.5 256 384 276.5 384 301.8v132.6C384 459.6 404.4 480 429.6 480c43.87 0 79.39-34.39 81.88-77.64c.123-.8027 .4724-1.586 .4724-2.424L512 287.9C507.4 151 399.1 32 256 32zM80 304.1v127.8c-17.85-1.215-32-16.12-32-34.28v-59.39C48 320.1 62.16 305.2 80 304.1zM432 431.9V304.1c17.84 1.164 32 16.05 32 34.18v59.39C464 415.8 449.8 430.7 432 431.9z" />
      </svg>
    </Tooltip>
  );
};
